export const getAllHotlistData = [
    {
        "businessObjectKey": "Univerus.Unity.Starter.Project.Models.UdpHotList|37c08456-d3a5-4bf0-9fb5-162f72bff33b",
        "hotListId": "37c08456-d3a5-4bf0-9fb5-162f72bff33b",
        "clusterId": 11,
        "domain": "Univerus.Unity.Starter.Project.Models.Vertical",
        "name": "My public hot list",
        "tenantId": "f86a9b7c-bab0-4281-89a2-52b4caf89fab",
        "isPrivate": false,
        "createdOn": "2023-11-28T10:02:54.6433333",
        "createdBy": "cce35aa2-218e-4ff1-9f2b-8a882bdbb5e4",
        "updatedOn": null,
        "updatedBy": null,
        "hotListTypeId": 2,
        "hotListDataSourceId": 1,
        "serializeFields": null,
        "type": null,
        "dataSource": null,
        "records": [],
        "sharedUsers": [],
        "udpTags": []
    },
    {
        "businessObjectKey": "Univerus.Unity.Starter.Project.Models.UdpHotList|15d4956a-1f15-4e57-84c9-7536108dbfbc",
        "hotListId": "15d4956a-1f15-4e57-84c9-7536108dbfbc",
        "clusterId": 12,
        "domain": "Univerus.Unity.Starter.Project.Models.Vertical",
        "name": "My private hot list",
        "tenantId": "f86a9b7c-bab0-4281-89a2-52b4caf89fab",
        "isPrivate": true,
        "createdOn": "2023-11-28T10:03:29.9533333",
        "createdBy": "cce35aa2-218e-4ff1-9f2b-8a882bdbb5e4",
        "updatedOn": null,
        "updatedBy": null,
        "hotListTypeId": 2,
        "hotListDataSourceId": 1,
        "serializeFields": null,
        "type": null,
        "dataSource": null,
        "records": [],
        "sharedUsers": [],
        "udpTags": []
    },
    {
        "businessObjectKey": "Univerus.Unity.Starter.Project.Models.UdpHotList|1e050f8f-d936-493b-98e8-7fbfdc893a4e",
        "hotListId": "1e050f8f-d936-493b-98e8-7fbfdc893a4e",
        "clusterId": 14,
        "domain": "Univerus.Unity.Starter.Project.Models.Vertical",
        "name": "Not my public hot list",
        "tenantId": "f86a9b7c-bab0-4281-89a2-52b4caf89fab",
        "isPrivate": false,
        "createdOn": "2023-11-28T10:31:52.98",
        "createdBy": "188b877b-e79e-4a75-8d98-ec72b838acf4",
        "updatedOn": null,
        "updatedBy": null,
        "hotListTypeId": 2,
        "hotListDataSourceId": 1,
        "serializeFields": null,
        "type": null,
        "dataSource": null,
        "records": [],
        "sharedUsers": [],
        "udpTags": []
    }
]


export const getAllHotlistsFull = [
    {
        "businessObjectKey": "Univerus.Unity.Starter.Project.Models.UdpHotList|37c08456-d3a5-4bf0-9fb5-162f72bff33b",
        "hotListId": "37c08456-d3a5-4bf0-9fb5-162f72bff33b",
        "clusterId": 11,
        "domain": "Univerus.Unity.Starter.Project.Models.Vertical",
        "name": "My public hot list",
        "tenantId": "f86a9b7c-bab0-4281-89a2-52b4caf89fab",
        "isPrivate": false,
        "createdOn": "2023-11-28T10:02:54.6433333",
        "createdBy": "cce35aa2-218e-4ff1-9f2b-8a882bdbb5e4",
        "updatedOn": null,
        "updatedBy": null,
        "hotListTypeId": 2,
        "hotListDataSourceId": 1,
        "serializeFields": null,
        "type": {
            "businessObjectKey": "Univerus.Unity.Starter.Project.Models.UdpHotListType|2",
            "hotListTypeId": 2,
            "name": "Reference",
            "description": null,
            "serializeFields": null,
            "hotLists": [],
            "udpTags": []
        },
        "dataSource": {
            "businessObjectKey": "Univerus.Unity.Starter.Project.Models.UdpHotListDataSource|1",
            "hotListDataSourceId": 1,
            "name": "Microsoft SQL",
            "description": null,
            "serializeFields": null,
            "hotLists": [],
            "udpTags": []
        },
        "records": [
            {
                "businessObjectKey": "Univerus.Unity.Mindscope.Project.Models.VClientContacts|218,1936",
                "hotListRecordId": "4664c141-51a3-4618-a128-c1d51ca3f281",
                "clusterId": 25,
                "data": "{\"businessObjectKey\":\"Univerus.Unity.Starter.Project.Models.Vertical|2\"}",
                "contextDate": "2023-11-16T15:47:19",
                "hotListId": "37c08456-d3a5-4bf0-9fb5-162f72bff33b",
                "serializeFields": null,
                "hotList": null,
                "udpTags": []
            },
            {
                "businessObjectKey": "Univerus.Unity.Mindscope.Project.Models.VClientContacts|82,2369",
                "hotListRecordId": "238a0868-0f07-4714-8ae1-267949fa8e8d",
                "clusterId": 26,
                "data": "{\"businessObjectKey\":\"Univerus.Unity.Starter.Project.Models.Vertical|3\"}",
                "contextDate": "2023-11-16T15:47:19",
                "hotListId": "37c08456-d3a5-4bf0-9fb5-162f72bff33b",
                "serializeFields": null,
                "hotList": null,
                "udpTags": []
            }
        ],
        "sharedUsers": [
            {
                "businessObjectKey": "Univerus.Unity.Starter.Project.Models.UdpSharedHotList|22c48b81-5bca-48c0-ac09-6ec9442d42ee",
                "sharedHotListId": "22c48b81-5bca-48c0-ac09-6ec9442d42ee",
                "hotListId": "37c08456-d3a5-4bf0-9fb5-162f72bff33b",
                "userId": "cce35aa2-218e-4ff1-9f2b-8a882bdbb5e4",
                "groupId": null,
                "sharedOn": "2023-11-28T10:02:54.7833333",
                "serializeFields": null,
                "hotList": null,
                "udpTags": []
            }
        ],
        "udpTags": []
    }
]